import Svg, { Path } from 'react-native-svg'
const Triangle = ({ color = '#0F3CC9' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={10} height={8} fill="none">
    <Path fill={color} d="M4.134.5a1 1 0 0 1 1.732 0l3.464 6A1 1 0 0 1 8.464 8H1.536A1 1 0 0 1 .67 6.5l3.464-6Z" />
  </Svg>
)
export default Triangle
